import zappy from "@zappy-ride/library.react.components";
import { Header } from "./Header";

export * from "./Header";

zappy.FactoryInstance.registerComponent(Header);
